"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var api_1 = require("../../api");
var loading_modal_1 = __importDefault(require("../../components/loading-modal"));
var update_next_charge_date_1 = require("../../mutations/update-next-charge-date");
var index_1 = require("./index");
var bundle_datepicker_1 = __importDefault(require("../../components/bundle-datepicker"));
var useContext = React.useContext, useState = React.useState, useMemo = React.useMemo;
exports.default = (function () {
    var _a = useContext(index_1.AppContext), goNext = _a.goNext, groupedSubscription = _a.groupedSubscription;
    if (!groupedSubscription)
        return null;
    var cancel = window.accountApp.settings.cancel;
    var _b = __read(useState(function () {
        var nextChargeScheduledAt = groupedSubscription.subscription.next_charge_scheduled_at;
        return nextChargeScheduledAt ? (0, date_fns_1.addWeeks)((0, date_fns_1.parseISO)(nextChargeScheduledAt), 2) : (0, date_fns_1.addWeeks)(new Date(), 4);
    }), 2), skipDate = _b[0], setSkipDate = _b[1];
    var skipDateFormatted = useMemo(function () { return (0, date_fns_1.format)(skipDate, 'MM/dd/yyyy'); }, [skipDate]);
    var queryClient = (0, react_query_1.useQueryClient)();
    var _c = (0, react_query_1.useMutation)("updateNextChargeDate", function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_next_charge_date_1.UPDATE_NEXT_CHARGE_DATE, variables); }, {
        onSuccess: function () { return queryClient.invalidateQueries('getCustomerSubscriptions'); },
    }), updateNextChargeDate = _c.mutateAsync, isUpdatingNextCharge = _c.isLoading, updateNextChargeError = _c.error;
    return (React.createElement("div", { className: 'padding-4 medium-padding-8' },
        React.createElement(loading_modal_1.default, { error: updateNextChargeError, isLoading: isUpdatingNextCharge }),
        React.createElement("div", { className: 'text-center' },
            React.createElement("div", { className: 'margin-bottom-4 font-lighter' }, cancel.topline),
            React.createElement("h3", null, cancel.title),
            React.createElement("div", { className: 'divider bg-cornflower-blue margin-vertical-4 margin-horizontal-auto' }),
            React.createElement("div", null, cancel.body)),
        React.createElement("div", { className: 'text-center margin-vertical-6' },
            React.createElement(bundle_datepicker_1.default, { selected: skipDate, onChange: function (newSkipDate) {
                    if (!newSkipDate)
                        return;
                    setSkipDate(newSkipDate);
                }, inline: true })),
        React.createElement("div", { className: 'grid-x grid-margin-x align-middle align-justify' },
            React.createElement("button", { className: 'cell medium-6 button wisteria padding-vertical-5', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var subscriptionId, nextChargeDate;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                subscriptionId = groupedSubscription.subscription.id;
                                nextChargeDate = (0, date_fns_1.format)(skipDate, 'yyyy-MM-dd');
                                return [4 /*yield*/, updateNextChargeDate({ nextChargeDate: nextChargeDate, subscriptionId: subscriptionId })];
                            case 1:
                                _a.sent();
                                window.location.href = "/account#/subscriptions/edit-items/".concat(subscriptionId, "?modal=afterSkipBundleCharge&modalOpt1=").concat(skipDateFormatted);
                                return [2 /*return*/];
                        }
                    });
                }); } }, cancel.skipChargeButtonText),
            React.createElement("button", { className: 'cell medium-6 button white small text-uppercase padding-vertical-5', id: 'account-cancel-skip-shipment-btn' // for GA
                , onClick: goNext },
                React.createElement("span", { className: 'bordered border-light-wisteria', style: { borderWidth: '0 0 1px', paddingBottom: '4px' } }, cancel.button)))));
});
